module.exports = __webpack_public_path__ + "media/images/index_bg-3e2d8742.svg";